import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { STATIC_CLASSES } from './Video4.const'

export const useVideo4 = props => {
	const { metaData } = props

	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	return [
		{
			classes: STATIC_CLASSES,
			direction: metaData.videoPosition?.metaValue,
			mobileDirection: metaData.mobileVideoPosition?.metaValue,

			mobileAlignment: metaData.mobileAlignment?.metaValue,
			mobileButtonWidth: metaData.mobileButtonWidth?.metaValue,

			video: metaData.video?.metaValue,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextConfig: metaData.buttonText?.config,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonTextEditable,
		},
		{
			handleTextClick,
			handleButtonClick,
			handleTextChange,
			handleButtonTextChange,
		},
	]
}
